var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpcoming(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.853,
    height: 24.889,
    viewBox: "0 0 22.853 24.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fireworks-svgrepo-com",
    transform: "translate(-12.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M26.624,147.013a.828.828,0,1,0,.586-.243A.833.833,0,0,0,26.624,147.013Z",
    transform: "translate(-13.038 -134.47)",
    fill: "#40ff91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M238.624,195.935a.828.828,0,1,0,.586-.243A.835.835,0,0,0,238.624,195.935Z",
    transform: "translate(-207.272 -179.293)",
    fill: "#40ff91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M141.362,34.272a.829.829,0,1,0-.586-.243A.833.833,0,0,0,141.362,34.272Z",
    transform: "translate(-117.625 -29.883)",
    fill: "#40ff91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M255.518,115.811a.828.828,0,1,0-.586-.243A.833.833,0,0,0,255.518,115.811Z",
    transform: "translate(-222.215 -104.589)",
    fill: "#40ff91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M59.824,1.657A.828.828,0,0,0,60.41.243a.828.828,0,1,0-1.171,1.171A.834.834,0,0,0,59.824,1.657Z",
    transform: "translate(-42.92)",
    fill: "#40ff91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M109.267,130.647a.828.828,0,0,0-1.038,1.291c4.525,3.638,7.918,11.883,7.952,11.966a.828.828,0,0,0,1.534-.624C117.571,142.925,114.129,134.556,109.267,130.647Z",
    transform: "translate(-87.744 -119.531)",
    fill: "#40ff91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M15.715,31.172,17.124,33.6a.828.828,0,0,0,.716.413l.056,0a.828.828,0,0,0,.71-.511l1.071-2.6,2.746-.59a.828.828,0,0,0,.363-1.44l-2.138-1.821.288-2.793a.828.828,0,0,0-1.258-.79l-2.392,1.47L14.717,23.8a.828.828,0,0,0-1.14.952l.66,2.73-1.875,2.091a.828.828,0,0,0,.553,1.379Zm.046-2.9a.828.828,0,0,0,.188-.747L15.581,26l1.432.634a.828.828,0,0,0,.769-.052l1.334-.82-.16,1.557a.828.828,0,0,0,.287.715l1.192,1.016-1.531.329a.829.829,0,0,0-.592.494l-.6,1.447-.786-1.354a.828.828,0,0,0-.653-.41l-1.561-.121Z",
    transform: "translate(0 -21.392)",
    fill: "#40ff91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M25.524,161.11l-1.534-.346-.585-1.46a.828.828,0,0,0-1.481-.115l-.8,1.352-1.569.105a.828.828,0,0,0-.567,1.373l1.038,1.182-.385,1.525a.828.828,0,0,0,1.131.963l1.444-.622,1.332.837a.828.828,0,0,0,1.266-.778l-.145-1.566,1.208-1.007a.828.828,0,0,0-.348-1.444Zm-2.255,1.458a.828.828,0,0,0-.294.712l.03.329-.279-.176a.827.827,0,0,0-.768-.06l-.3.13.081-.32a.828.828,0,0,0-.181-.749l-.218-.248.329-.022a.829.829,0,0,0,.657-.4l.168-.284.123.306a.828.828,0,0,0,.587.5l.322.073Z",
    transform: "translate(-6.073 -145.478)",
    fill: "#40ff91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M182.223,28.98,180.5,27.5l.232-2.264a.828.828,0,0,0-1.259-.789l-1.924,1.189-2.065-.919a.828.828,0,0,0-1.142.95l.532,2.213-1.511,1.694a.828.828,0,0,0,.554,1.377l2.253.175L177.3,33.1a.828.828,0,0,0,.717.414l.056,0a.828.828,0,0,0,.711-.512l.862-2.1,2.209-.477a.828.828,0,0,0,.364-1.439Zm-3.349.388a.828.828,0,0,0-.592.5l-.387.945-.51-.883a.828.828,0,0,0-.653-.412l-1.021-.079.687-.77a.828.828,0,0,0,.187-.745l-.241-1,.931.414a.828.828,0,0,0,.772-.052l.866-.535-.1,1.022a.828.828,0,0,0,.285.713l.784.671Z",
    transform: "translate(-147.51 -22.289)",
    fill: "#40ff91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M190.065,118.7a8.755,8.755,0,0,1-.2-3.52.828.828,0,0,0-1.608-.4c-.06.24-1.388,5.971,5.634,14.4a.828.828,0,0,0,1.273-1.061A22.864,22.864,0,0,1,190.065,118.7Z",
    transform: "translate(-161.218 -104.585)",
    fill: "#40ff91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M111.344,213.386a7.922,7.922,0,0,0-2.318-1.345.828.828,0,0,0-.527,1.571c.144.049,3.536,1.245,3.536,4.681a.828.828,0,1,0,1.657,0A6.232,6.232,0,0,0,111.344,213.386Z",
    transform: "translate(-87.76 -194.233)",
    fill: "#40ff91"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcoming);
export default __webpack_public_path__ + "static/media/upcoming.ae77a0a5de4258ef100bda7058f0cd21.svg";
export { ForwardRef as ReactComponent };